// util
import { defineStore } from 'pinia';
import request from '@/utils/request';

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: {} // 用户信息
  }),
  actions: {
    // 设置用户信息
    setUserInfo(userInfo) {
      this.userInfo = userInfo;
    },
    // 健康权益查询
    queryHealthQuanyi() {
      return request({
        method: 'get',
        url: SEVSRS + `/equity/v2/detail`,
        noLoading: true
      });
    },
    // 预警事件列表查询
    queryWarnEventList() {
      return request({
        method: 'get',
        url: SEVSRS + `/monitor/v1/abnormal/list?userCode=${this.userInfo.userCode}`,
        headers: { client: 'iosandroid' }
      });
    },
    // 提交意见反馈
    insertFeedback(data) {
      return request({
        method: 'post',
        url: SEVSRS + `/user/v1/feedback`,
        data
      });
    }
  },
  persist: {
    key: 'userStore',
    storage: localStorage,
  }
})



// WEBPACK FOOTER //
// ./src/stores/user.js